import { createSlice } from "@reduxjs/toolkit";
import { factory } from "../../../api/apiFactory";
import { showNotification } from "../notificationSlice";
const seekerApi = factory.get("seeker");
const initialState = {
  seeker: {
    loading: false,
    exporting: false,
    data: [],
    total: 0,
    filters: {
      page: 0,
      skip: 0,
      take: 25,
      search: null,
      gender: null,
      province_id: null,
      city_id: null,
      has_driver_license: null,
      has_cv: null,
    },
    dialog: false,
  },
  seekerProfile: {
    loading: false,
    dialog: false,
    profile: {
      id: "",
    },
    total: 0,
  },
};

export const seekerSlice = createSlice({
  name: "seeker",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state[action.payload].loading = !state[action.payload].loading;
    },
    setExporting: (state) => {
      state.seeker.exporting = !state.seeker.exporting;
    },
    setSeeker: (state, action) => {
      state.seeker.data = action.payload.data;
      state.seeker.total = action.payload.total;
    },
    setSeekerProfile: (state, action) => {
      state.seekerProfile.profile = action.payload;
    },
    setSeekerProfileDialog: (state, action) => {
      if (action.payload?.id) {
        state.seekerProfile.profile.id = action.payload.id;
      }
      state.seekerProfile.dialog = !state.seekerProfile.dialog;
    },
    setFilters: (state, { payload }) => {
      state.seeker.filters = {
        ...state.seeker.filters,
        ...payload,
      };
    },
    resetFilters: (state) => {
      state.seeker.filters = initialState.seeker.filters;
    },
    setFiltersDialog: (state) => {
      state.seeker.dialog = !state.seeker.dialog;
    },
  },
});

export const {
  setLoading,
  setExporting,
  setSeeker,
  setFilters,
  resetFilters,
  setSeekerProfile,
  setSeekerProfileDialog,
  setFiltersDialog,
} = seekerSlice.actions;

export default seekerSlice.reducer;

const index = () => async (dispatch, getState) => {
  try {
    const filters = getState().seeker.seeker.filters;
    dispatch(setLoading("seeker"));
    const res = await seekerApi.index(filters);
    dispatch(setSeeker(res.data));
    dispatch(setLoading("seeker"));
  } catch (err) {
    dispatch(setLoading("seeker"));
    console.log(err);
  }
};

const showById = (id) => async (dispatch, getState) => {
  try {
    dispatch(setLoading("seekerProfile"));
    const res = await seekerApi.show(id);
    dispatch(setSeekerProfile(res.data?.data[0]));
    dispatch(setLoading("seekerProfile"));
  } catch (err) {
    dispatch(setLoading("seekerProfile"));
    console.log(err);
  }
};

const deleteSeeker = (id) => async (dispatch, getState) => {
  try {
    await seekerApi.delete(id);
    dispatch(
      showNotification({
        type: "success",
        message: "Seeker deleted successfully",
      })
    );
    dispatch(index());
  } catch (err) {
    dispatch(
      showNotification({
        type: "error",
        message: err.response.data.errors[0],
      })
    );
    console.log(err);
  }
};

const exportExcel = () => async (dispatch, getState) => {
  try {
    const filters = getState().seeker.seeker.filters;
    dispatch(setExporting());
    const res = await seekerApi.exportExcel(filters);
    
    // Create blob URL and trigger download
    const blob = new Blob([res.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `seekers_${new Date().toISOString().split('T')[0]}.xlsx`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    
    dispatch(setExporting());
    dispatch(
      showNotification({
        type: "success",
        message: "Seekers exported successfully",
      })
    );
  } catch (err) {
    dispatch(setExporting());
    dispatch(
      showNotification({
        type: "error",
        message: err.response?.data?.errors?.[0] || "Failed to export seekers",
      })
    );
    console.log(err);
  }
};

export const Seeker = {
  index,
  showById,
  deleteSeeker,
  exportExcel,
};
